module.exports = __webpack_public_path__ + "img/iizuka-umito.242ca69a.jpg";